// import Monitor from '@/views/wind-data/wind-monitor/index';
// import Warn from '@/views/wind-data/wind-monitor/warn';
// import Collect from '@/views/wind-data/wind-monitor/collect';

export default [
  {
    name: 'wind-data',
    path: '/wind-data',
    components: {
      Home: () => import('@/views/wind-data/index/index')
    },
    redirect: '/wind-data/tower-manage',
    children: [
      // {
      //   name: 'wind-map',
      //   path: '/wind-data/map',
      //   components: {
      //     content: () => import('@/views/wind-data/index/map')
      //   }
      // },
      {
        name: 'tower-manage',
        path: '/wind-data/tower-manage',
        components: {
          content: () => import('@/views/wind-data/tower-manage/index')
        }
        // components: () => import('@/views/wind-data/tower-manage/index')
      },
      {
        name: 'parameter-analysis',
        path: '/wind-data/parameter-analysis',
        components: {
          content: () => import('@/views/wind-data/parameter-analysis/index')
        },
        redirect: '/wind-data/parameter-analysis/info',
        children: [
          {
            name: 'info',
            path: '/wind-data/parameter-analysis/info',
            component: () =>
              import(
                '@/views/wind-data/parameter-analysis/basic-wind-condition'
              )
          },
          {
            name: 'speed',
            path: '/wind-data/parameter-analysis/speed',
            component: () =>
              import('@/views/wind-data/parameter-analysis/speed-change')
          },
          {
            name: 'rose',
            path: '/wind-data/parameter-analysis/rose',
            component: () =>
              import('@/views/wind-data/parameter-analysis/rose-profile')
          },
          {
            name: 'weibull',
            path: '/wind-data/parameter-analysis/weibull',
            component: () =>
              import(
                '@/views/wind-data/parameter-analysis/weibull-distribution'
              )
          },
          {
            name: 'swift',
            path: '/wind-data/parameter-analysis/swift',
            component: () =>
              import(
                '@/views/wind-data/parameter-analysis/turbulence-statistics'
              )
          },
          {
            name: 'shear',
            path: '/wind-data/parameter-analysis/shear',
            component: () =>
              import('@/views/wind-data/parameter-analysis/wind-shear')
          }
        ]
      },
      {
        name: 'data-process',
        path: '/wind-data/data-process',
        components: {
          content: () => import('@/views/wind-data/data-process/index')
        },
        redirect: '/wind-data/data-process/integrity-analysis',
        children: [
          // 完整性分析
          {
            name: 'integrity-analysis',
            path: '/wind-data/data-process/integrity-analysis',
            meta: {
              title: '完整性分析'
            },
            component: () =>
              import('@/views/wind-data/data-process/integrity-analysis')
          },
          //  插补延长
          {
            name: 'interpolation-extension',
            path: '/wind-data/data-process/interpolation-extension',
            meta: {
              title: '插补延长'
            },
            component: () =>
              import('@/views/wind-data/data-process/interpolation-extension')
          },
          // 合理性验证
          {
            name: 'interpolation-extension',
            path: '/wind-data/data-process/rationality-verification',
            meta: {
              title: '合理性验证'
            },
            component: () =>
              import('@/views/wind-data/data-process/rationality-verification')
          },
          // 代表年订正
          {
            name: 'interpolation-extension',
            path: '/wind-data/data-process/year-revision',
            meta: {
              title: '代表年订正'
            },
            component: () =>
              import('@/views/wind-data/data-process/year-revision')
          }
        ]
      },
      {
        name: 'wind-monitor',
        path: '/wind-data/wind-monitor',
        components: {
          content: () => import('@/views/wind-data/wind-monitor/index')
        }
        // children: [
        //   {
        //     path: 'warn',
        //     component: Warn
        //   },
        //   {
        //     path: 'collect',
        //     component: Collect
        //   }
        // ]
      }
    ]
  }
  // {
  //   name: 'wind-data-process',
  //   path: '/wind-data/wind-data-process',
  //   components: {
  //     Home: () => import('@/views/wind-data/wind-data-process/index.vue')
  //   },
  //   children: [
  //     {
  //       name: 'data-dispose',
  //       path: 'data-dispose',
  //       components: {
  //         content: () => import('@/views/wind-data/components/wind-data-modify')
  //       },
  //       children: [
  //         {
  //           name: 'air-density',
  //           path: 'air-density',
  //           components: {
  //             datamodify: () =>
  //               import('@/views/wind-data/wind-data-process/air-density')
  //           }
  //         },
  //         {
  //           name: 'turbulence-correction',
  //           path: 'turbulence-correction',
  //           components: {
  //             datamodify: () =>
  //               import(
  //                 '@/views/wind-data/wind-data-process/turbulence-correction'
  //               )
  //           }
  //         },
  //         {
  //           name: 'integrity-analysis',
  //           path: 'integrity-analysis',
  //           components: {
  //             datamodify: () =>
  //               import('@/views/wind-data/wind-data-process/integrity-analysis')
  //           }
  //         },
  //         {
  //           name: 'interpolation-extension',
  //           path: 'interpolation-extension',
  //           components: {
  //             datamodify: () =>
  //               import(
  //                 '@/views/wind-data/wind-data-process/interpolation-extension'
  //               )
  //           }
  //         },
  //         {
  //           name: 'magnetic-declination',
  //           path: 'magnetic-declination',
  //           components: {
  //             datamodify: () =>
  //               import(
  //                 '@/views/wind-data/wind-data-process/magnetic-declination'
  //               )
  //           }
  //         },
  //         {
  //           name: 'rationality-verification',
  //           path: 'rationality-verification',
  //           components: {
  //             datamodify: () =>
  //               import(
  //                 '@/views/wind-data/wind-data-process/rationality-verification'
  //               )
  //           }
  //         },
  //         {
  //           name: 'year-revision',
  //           path: 'year-revision',
  //           components: {
  //             datamodify: () =>
  //               import('@/views/wind-data/wind-data-process/year-revision')
  //           }
  //         },
  //         {
  //           name: 'tower-shadow-effect',
  //           path: 'tower-shadow-effect',
  //           components: {
  //             datamodify: () =>
  //               import(
  //                 '@/views/wind-data/wind-data-process/tower-shadow-effect'
  //               )
  //           }
  //         },
  //         {
  //           name: 'vertical-extrapolation',
  //           path: 'vertical-extrapolation',
  //           components: {
  //             datamodify: () =>
  //               import(
  //                 '@/views/wind-data/wind-data-process/vertical-extrapolation'
  //               )
  //           }
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   name: 'wind-parameter-analysis',
  //   path: '/wind-data/wind-parameter-analysis',
  //   components: {
  //     Home: () => import('@/views/wind-data/wind-parameter-analysis/index')
  //   },
  //   children: [
  //     {
  //       name: 'resource-analysis',
  //       path: 'resource-analysis',
  //       components: {
  //         content: () =>
  //           import(
  //             '@/views/wind-data/components/wind-resource-parameter-analysis'
  //           )
  //       },
  //       children: [
  //         {
  //           name: 'basic-wind-condition',
  //           path: 'basic-wind-condition',
  //           components: {
  //             paramAnalysis: () =>
  //               import(
  //                 '@/views/wind-data/wind-parameter-analysis/basic-wind-condition'
  //               )
  //           }
  //         },
  //         {
  //           name: 'extreme-speed',
  //           path: 'extreme-speed',
  //           components: {
  //             paramAnalysis: () =>
  //               import(
  //                 '@/views/wind-data/wind-parameter-analysis/extreme-speed'
  //               )
  //           }
  //         },
  //         {
  //           name: 'rose-profile',
  //           path: 'rose-profile',
  //           components: {
  //             paramAnalysis: () =>
  //               import('@/views/wind-data/wind-parameter-analysis/rose-profile')
  //           }
  //         },
  //         {
  //           name: 'speed-change',
  //           path: 'speed-change',
  //           components: {
  //             paramAnalysis: () =>
  //               import('@/views/wind-data/wind-parameter-analysis/speed-change')
  //           }
  //         },
  //         {
  //           name: 'turbulence-statistics',
  //           path: 'turbulence-statistics',
  //           components: {
  //             paramAnalysis: () =>
  //               import(
  //                 '@/views/wind-data/wind-parameter-analysis/turbulence-statistics'
  //               )
  //           }
  //         },
  //         {
  //           name: 'weibull-distribution',
  //           path: 'weibull-distribution',
  //           components: {
  //             paramAnalysis: () =>
  //               import(
  //                 '@/views/wind-data/wind-parameter-analysis/weibull-distribution'
  //               )
  //           }
  //         },
  //         {
  //           name: 'wind-shear',
  //           path: 'wind-shear',
  //           components: {
  //             paramAnalysis: () =>
  //               import('@/views/wind-data/wind-parameter-analysis/wind-shear')
  //           }
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   name: 'wind-manage',
  //   path: '/wind-data/wind-manage',
  //   components: {
  //     Home: () => import('@/views/wind-data/wind-manage/index')
  //   },
  //   children: [
  //     {
  //       name: 'tower-manage',
  //       path: 'tower-manage',
  //       components: {
  //         content: () =>
  //           import(
  //             '@/views/wind-data/components/wind-monitortower-manage-right'
  //           )
  //       }
  //     },
  //     {
  //       name: 'data-dispose',
  //       path: 'data-dispose',
  //       components: {
  //         content: () => import('@/views/wind-data/components/wind-data-modify')
  //       },
  //       children: [
  //         {
  //           name: 'air-density',
  //           path: 'air-density',
  //           components: {
  //             datamodify: () =>
  //               import('@/views/wind-data/wind-data-process/air-density')
  //           }
  //         },
  //         {
  //           name: 'turbulence-correction',
  //           path: 'turbulence-correction',
  //           components: {
  //             datamodify: () =>
  //               import(
  //                 '@/views/wind-data/wind-data-process/turbulence-correction'
  //               )
  //           }
  //         },
  //         {
  //           name: 'integrity-analysis',
  //           path: 'integrity-analysis',
  //           components: {
  //             datamodify: () =>
  //               import('@/views/wind-data/wind-data-process/integrity-analysis')
  //           }
  //         },
  //         {
  //           name: 'interpolation-extension',
  //           path: 'interpolation-extension',
  //           components: {
  //             datamodify: () =>
  //               import(
  //                 '@/views/wind-data/wind-data-process/interpolation-extension'
  //               )
  //           }
  //         },
  //         {
  //           name: 'magnetic-declination',
  //           path: 'magnetic-declination',
  //           components: {
  //             datamodify: () =>
  //               import(
  //                 '@/views/wind-data/wind-data-process/magnetic-declination'
  //               )
  //           }
  //         },
  //         {
  //           name: 'rationality-verification',
  //           path: 'rationality-verification',
  //           components: {
  //             datamodify: () =>
  //               import(
  //                 '@/views/wind-data/wind-data-process/rationality-verification'
  //               )
  //           }
  //         },
  //         {
  //           name: 'year-revision',
  //           path: 'year-revision',
  //           components: {
  //             datamodify: () =>
  //               import('@/views/wind-data/wind-data-process/year-revision')
  //           }
  //         },
  //         {
  //           name: 'tower-shadow-effect',
  //           path: 'tower-shadow-effect',
  //           components: {
  //             datamodify: () =>
  //               import(
  //                 '@/views/wind-data/wind-data-process/tower-shadow-effect'
  //               )
  //           }
  //         },
  //         {
  //           name: 'vertical-extrapolation',
  //           path: 'vertical-extrapolation',
  //           components: {
  //             datamodify: () =>
  //               import(
  //                 '@/views/wind-data/wind-data-process/vertical-extrapolation'
  //               )
  //           }
  //         }
  //       ]
  //     },
  //     {
  //       name: 'resource-analysis',
  //       path: 'resource-analysis',
  //       components: {
  //         content: () =>
  //           import(
  //             '@/views/wind-data/components/wind-resource-parameter-analysis'
  //           )
  //       },
  //       children: [
  //         {
  //           name: 'basic-wind-condition',
  //           path: 'basic-wind-condition',
  //           components: {
  //             paramAnalysis: () =>
  //               import(
  //                 '@/views/wind-data/wind-parameter-analysis/basic-wind-condition'
  //               )
  //           }
  //         },
  //         {
  //           name: 'extreme-speed',
  //           path: 'extreme-speed',
  //           components: {
  //             paramAnalysis: () =>
  //               import(
  //                 '@/views/wind-data/wind-parameter-analysis/extreme-speed'
  //               )
  //           }
  //         },
  //         {
  //           name: 'rose-profile',
  //           path: 'rose-profile',
  //           components: {
  //             paramAnalysis: () =>
  //               import('@/views/wind-data/wind-parameter-analysis/rose-profile')
  //           }
  //         },
  //         {
  //           name: 'speed-change',
  //           path: 'speed-change',
  //           components: {
  //             paramAnalysis: () =>
  //               import('@/views/wind-data/wind-parameter-analysis/speed-change')
  //           }
  //         },
  //         {
  //           name: 'turbulence-statistics',
  //           path: 'turbulence-statistics',
  //           components: {
  //             paramAnalysis: () =>
  //               import(
  //                 '@/views/wind-data/wind-parameter-analysis/turbulence-statistics'
  //               )
  //           }
  //         },
  //         {
  //           name: 'weibull-distribution',
  //           path: 'weibull-distribution',
  //           components: {
  //             paramAnalysis: () =>
  //               import(
  //                 '@/views/wind-data/wind-parameter-analysis/weibull-distribution'
  //               )
  //           }
  //         },
  //         {
  //           name: 'wind-shear',
  //           path: 'wind-shear',
  //           components: {
  //             paramAnalysis: () =>
  //               import('@/views/wind-data/wind-parameter-analysis/wind-shear')
  //           }
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   name: 'wind-monitor',
  //   path: '/wind-data/wind-manage/wind-monitor',
  //   components: {
  //     Home: Monitor
  //   },
  //   children: [
  //     {
  //       path: 'warn',
  //       component: Warn
  //     },
  //     {
  //       path: 'collect',
  //       component: Collect
  //     }
  //   ]
  // }
];
